import React,  {useEffect,useState} from 'react';
import {FormControl , TextField, Grid , Box, Card, CardContent  ,Tooltip,IconButton, Typography,CardActions,Button } from '@mui/material/';
import axios from 'axios';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import OfficerInfo from '../../components/clubs/officers_info';
import Autorize from '../../components/ui/autorize';
import { DataGrid, GridToolbar  } from '@mui/x-data-grid';

import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import FmdGoodIcon from '@mui/icons-material/FmdGood';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import ErrorIcon from '@mui/icons-material/Error';
import Cookies from 'js-cookie'
import NewOfficier from './officers_new';
import EditOfficier from './officers_edit';
//https://react-data-table-component.netlify.app/?path=/docs/examples-filtering--filtering


//myDate -> 0=curent ; 1=nextyear
function Officiers({clubid,secteur,addyear,ruleWrite }) {
  
    const [modalOfficierOpenNew, setModalOfficierOpenNew] = useState(false);
    const [modalOfficierOpenEdit, setModalOfficierOpenEdit] = useState(false);
    const [editmode, setEditmode] = useState("");
    const [officerlist, setOfficerlist] = useState("");
    const [modalOpenInfo, setModalOpenInfo] = useState(false);
    const [rid, setCurrentRid] = useState("");
    const [autorize, setAutorize] = useState("false");
    const [errorAxios, setErrorAxios] = useState("false");

   /*
    const MyAxios = axios.create({
        headers: { 'Access-Control-Allow-Origin':  process.env.REACT_APP_API},       
        withCredentials: true,
        xsrfCookieName: 'token',
        xsrfHeaderName: 'X-XSRF-TOKEN',
    })*/
const MyAxios = axios.create({    
    headers: { Authorization: "Bearer "+ Cookies.get('token'),
            }      
})

  
    useEffect(() => {

        if(autorize)
           refreshLoadData();
    
        },[clubid,secteur,addyear,autorize]);


    function refreshLoadData()
    {       
        if(clubid !== "")
        {           
                MyAxios.get(process.env.REACT_APP_API + '/officers/get/secteur/'+ secteur +'/club/'+ clubid + '/year/' + addyear)
                .then((res) => {     
                    setErrorAxios(false);               
                    setOfficerlist(res.data);   
                    //console.log(officerlist);                    
                })
                .catch((error) => {
                    setErrorAxios(true); 
                });
        }   

    }


    function closeModal() {
        setModalOpenInfo(false);
    }


       
    const editOfficer = (value) => { 
       console.log("!*******:" + value);      
       setCurrentRid(value);         
       setModalOfficierOpenEdit(true);
    };

    
    function closeModalOfficier()
    {
      
        refreshLoadData();
        setModalOfficierOpenEdit(false);
        setModalOfficierOpenNew(false);
        
    }

    function callbackCloseDialog()
    {
        closeModalOfficier();   
    }
    
    
    const onNewOfficier = (row, event) => {   
       
        setCurrentRid("new");
        setModalOfficierOpenNew(true);
      
    };

    const title = () => {   
      
        
       var DisplayYear = "";
        var CurrentDate = new Date();
        DisplayYear = CurrentDate.getFullYear();
        var mois = CurrentDate.getMonth()+1;
      

        if(mois >= 10) // octobre décembre
             DisplayYear = CurrentDate.getFullYear();

        if(mois <= 9) // octobre décembre
             DisplayYear = DisplayYear-1
      
       
        if(addyear == '0')
            return <div>Rapport d’élection des dirigeants du <br />1<sup>er</sup> octobre {DisplayYear} au 30 septembre {DisplayYear+1}</div>;

        if(addyear == '1')
            return <>Dirigeants l'année prochaine au 1<sup>er</sup> octobre</>;
        
    };
         

    const callbackAutoriser = (index) => { // the callback. Use a better name      
        setAutorize(index);     
    };

    function getButtonAddSave()
    {
       if(ruleWrite === true)
           return(   <Button variant="containedFifth" name="NewOfficier" onClick={(e) => onNewOfficier("new")}>Ajouter un Dirigeant</Button>      );
    }

    function getButtonEdit(value)
    {
       if(ruleWrite === true)
           return(   <Button variant="containedThird" name={value.rid} onClick={(e) => editOfficer(e.target.name)}>MODIFIER</Button>       );
    }

    
  function getCardIcon(myDate1,myDate2){       
       
//alert(myDate1.substr(5,5));
    if (myDate1.substr(5,5) !== "10-01" || myDate2.substr(5,5) !== "09-30"   )
        return <Tooltip title={<h2 style={{ color: "lightblue" }}>Les dates ne sont pas standard.Ceci est simplement pour vous en aviser</h2>}  style={{ fontSize: '32px' }} placement="right">
                    <IconButton>
                        <ErrorIcon style={{ color: 'orange', fontSize: '24px' }} /> 
                    </IconButton> 
                </Tooltip>;
    else
        return <Tooltip title={<h2 style={{ color: "lightblue" }}>Date valide </h2>}  style={{ fontSize: '32px' }} placement="right">
                    <IconButton>
                        <CheckCircleIcon style={{ color: 'lightblue', fontSize: '24px' }} /> 
                    </IconButton> 
                </Tooltip>;
}



        return (
            <div>
                <Autorize axiosError={errorAxios} callBackAutoriser={callbackAutoriser}/>
            
                <Grid container direction="row" spacing={2}>
                    <Grid item xs={6}> 
                        <Typography variant="h6" gutterBottom> {title()}  </Typography>
                    </Grid>
                    <Grid item xs={5}> 
                         {getButtonAddSave()}     
                    </Grid> 
                </Grid>

                <Grid container direction="row" spacing={2}>
              
                    <Box  sx={{display: 'flex', flexDirection: 'row' }} >
                    
                    {Object.entries(officerlist).map(([key, value]) => (

                        <Card sx={{ maxWidth: 645 , margin:'10px' }} key={key}>               
                        <CardContent>
                            <Typography variant="h7" component="h7">
                            {value.Title} 
                            </Typography><br />
                            <Typography variant="h8" component="h8">
                            {value.First_Name  }  {value.Last_Name  } 
                            </Typography>
                            <Typography sx={{ mb: 1.5 }} color="text.secondary">
                            {value.Address}<br />
                            {value.City} {value.State_Province_Code} {value.Postal_Code}
                            </Typography>
                            
                            <Typography variant="body2"  color="text.secondary">
                            {value.effectif}  {getCardIcon(value.Effective_Date,value.Date_Deleted)} <br />
                             Date début: {value.Effective_Date  }<br />
                             Date fin: {value.Date_Deleted  }<br />
                            </Typography>
                        </CardContent>
                        

                        <CardActions>
                        
                             {getButtonEdit(value)}
                            
                            

                        </CardActions>
                        </Card>
                    

                    
                    ))}
  
                    </Box>
               
                </Grid>




                <Dialog
                            sx={{ '& .MuiDialog-paper': { maxWidth: '90%', maxHeight: '90%' } }}
                            maxWidth="xs"
                        
                            open={modalOfficierOpenEdit}
                        
                            >
                            <DialogTitle>Changement dirigeant</DialogTitle>
                            <DialogContent dividers>
                                <EditOfficier   recordId={rid}   clubid={clubid}  secteur={secteur} addyear={addyear} callback={callbackCloseDialog}/>
                            </DialogContent>

                            <DialogActions>
                            <Button variant="containedSecondary" onClick={closeModalOfficier}>Fermer               
                            </Button>

                            </DialogActions>
                    </Dialog>


                    <Dialog
                            sx={{ '& .MuiDialog-paper': { maxWidth: '90%', maxHeight: '90%' } }}
                            maxWidth="xs"
                        
                            open={modalOfficierOpenNew}
                        
                            >
                            <DialogTitle>Nouveau dirigeant</DialogTitle>
                            <DialogContent dividers>
                                <NewOfficier   recordId={rid}   clubid={clubid}  secteur={secteur} addyear={addyear} callback={callbackCloseDialog}/>
                            </DialogContent>

                            <DialogActions>
                            <Button variant="containedSecondary" onClick={closeModalOfficier}>Fermer               
                            </Button>

                            </DialogActions>
                    </Dialog>

                    
             
                    
          </div>

        );
       
    
}

export default Officiers;